export default "__VITE_ASSET__C$RtLfRE__"